import queryLoopLoaded from "@plaudit/query-loop.api";

import QueryLoopFormFieldBase from "./QueryLoopFormFieldBase";

export class DropdownQueryLoopFormField extends QueryLoopFormFieldBase {
	private readonly input: HTMLSelectElement;

	public constructor(field: HTMLFieldSetElement, type: string) {
		super(field, type);
		const input = field.querySelector('.plauditQueryLoopField__input');
		if (input instanceof HTMLSelectElement) {
			this.input = input;
		} else {
			throw new Error("Attempted to attach an invalid field");
		}
		this.postConstruct();
	}

	public getValue(): string|string[] {
		if (this.input.multiple) {
			const res: string[] = [];
			for (const option of this.input.selectedOptions) {
				res.push(option.value);
			}
			return res;
		} else {
			return this.input.value;
		}
	}
	public setValue(value: string|string[]) {
		let changed = false;
		if (this.input.multiple || Array.isArray(value)) {
			if (typeof value === 'string') {
				value = [value];
			}
			for (const option of this.input.options) {
				const selected = value.includes(option.value);
				if (option.selected !== selected) {
					option.selected = selected;
					changed = true;
				}
			}
		} else if (this.input.value !== value) {
			this.input.value = value;
			changed = true;
		}
		if (changed) {
			this.updateValueIsDefaultFlag();
		}
		return changed;
	}

	public loadIntoQuery(params: URLSearchParams) {
		this.replaceMyPotentialPHPArrayParametersWithFirstValue(params); //TODO: Change this if adding support for multiple
		let value = this.getValue();
		if (Array.isArray(value)) {
			//TODO: Add full support for multiple
			value = value.join(',');
		}
		if (value) {
			if (params.get(this.name) !== value) {
				params.set(this.name, value);
			}
			return true;
		} else {
			params.delete(this.name);
			return false;
		}
	}
	public loadFromQuery(params: URLSearchParams) {
		//TODO: Add full support for multiple
		let changed = false;
		for (const option of this.input.options) {
			if (params.get(this.name) === option.value) {
				if (!option.selected) {
					option.selected = true;
					changed = true;
				}
			} else if (option.selected) {
				option.selected = false;
				changed = true;
			}
		}
		return changed;
	}

	public getLabeledValues(selectedOnly = false) {
		const res: plaudit.queryLoop.LabeledValue[] = [];
		const defaultValue = this.getDefaultValue(true);
		for (const option of (selectedOnly ? this.input.selectedOptions : this.input.options)) {
			if (!selectedOnly || !defaultValue.includes(option.value)) {
				res.push({field: this.name, value: option.value, label: option.label});
			}
		}
		return res;
	}

	protected getDefaultValue(forceArray = false): string|string[] {
		const res: string[] = [];
		for (const option of this.input.options) {
			if (option.getAttribute('data-default') === 'true') {
				res.push(option.value);
			}
		}
		if (res.length === 0) {
			res.push(this.input.options[0]?.value ?? '');
		}
		return this.input.multiple || forceArray || res.length > 1 ? res : res[0];
	}

	public remove(value: string): boolean {
		const res = super.remove(value);
		if (this.input.multiple || this.input.selectedOptions.length) {
			return res;
		}
		const defaultValue = this.getDefaultValue() || this.input.options.item(0)?.value;
		if (defaultValue) {
			this.setValue(defaultValue);
		}
		return res;
	}

	public isSingleValued() {
		return true; //TODO: Change this if adding support for multivalued
	}
}

queryLoopLoaded.then(() => {
	plaudit.queryLoop.fieldTypes.set('dropdown', field => new DropdownQueryLoopFormField(field, 'dropdown'));
});
